import { useCallback, useEffect, useState } from "react";
import { getPublicPlansAsync } from "../api/SubscriptionApi";
import { Plan } from "../models/SubscriptionModels";
import { Constants } from "../constants/constants";

interface UsePlansReturn {
  plans: Plan[];
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

// Public active plans only — the backend already filters isPublic / isActive,
// so hidden "Free" plans never reach the dropdown.
export const usePlans = (lazy = false): UsePlansReturn => {
  const [plans, setPlans] = useState<Plan[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem(Constants.ACCESS_TOKEN) || "";
      const res = await getPublicPlansAsync(token);
      if (res.success) {
        setPlans(res.result ?? []);
        setError(null);
      } else {
        setPlans([]);
        setError(res.message || "Failed to load plans");
      }
    } catch (err) {
      console.error(err);
      setPlans([]);
      setError("Failed to load plans");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (!lazy) load();
  }, [load, lazy]);

  const reload = useCallback(async () => {
    await load();
  }, [load]);

  return { plans, loading, error, reload };
};